import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, CreditCard } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useMyPlan } from '@/hooks/useMyPlan';

export function PlanCard() {
  const navigate = useNavigate();
  const { plan } = useMyPlan();
  if (!plan) return null;
  const pro = plan.tier.price_gbp > 0;
  return (
    <Card className={`p-4 flex flex-wrap items-center justify-between gap-3 ${pro ? 'border-[#006400]/40 bg-[#006400]/5' : 'border-amber-300 bg-amber-50/60'}`} data-testid="settings-plan-card">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${pro ? 'bg-[#006400]/10 text-[#006400]' : 'bg-amber-100 text-amber-700'}`}>{pro ? <Sparkles className="w-5 h-5" /> : <CreditCard className="w-5 h-5" />}</div>
        <div>
          <p className="font-semibold text-gray-900 text-sm">Plan: <span data-testid="settings-plan-tier">{plan.tier.name}</span></p>
          <p className="text-xs text-gray-500">{pro ? 'Customer texts and crew day sheets unlocked.' : 'Upgrade to Pro (£19.99/mo) to text customers their install dates and send crew day sheets.'}</p>
        </div>
      </div>
      <Button type="button" variant={pro ? 'outline' : 'default'} size="sm" className={pro ? '' : 'bg-[#006400] hover:bg-[#004d00] text-white'} onClick={() => navigate('/billing')} data-testid="settings-plan-btn">{pro ? 'Manage plan' : 'See Pro'}</Button>
    </Card>
  );
}
